import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=7ff7cc5b&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=ts&"
export * from "./page-header.vue?vue&type=script&lang=ts&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=7ff7cc5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff7cc5b",
  null
  
)

export default component.exports